import { render } from "./AdminProjects.vue?vue&type=template&id=24ddb1f9&scoped=true"
import script from "./adminprojects.view.js?vue&type=script&lang=js&external"
export * from "./adminprojects.view.js?vue&type=script&lang=js&external"

import "./adminprojects.css?vue&type=style&index=0&id=24ddb1f9&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ddb1f9"]])

export default __exports__